import { Component, Inject } from '@angular/core';
import { MatDialogRef as MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import _ from 'lodash';

export interface ArchivesDialogOptions {
    title: string;
    text: string;
    hint?: string;
    valid: string;
    noConfirm: boolean;
    later?: string;
    rawText?: boolean;
    loading?: boolean;
    loadingText?: string;
}

@Component({
    selector: 'app-archives-dialog',
    templateUrl: './archives-dialog.component.html',
    styleUrls: ['./archives-dialog.component.scss']
})
export class ArchivesDialogComponent {
    protected _defaultCtx: ArchivesDialogOptions = {
        title: '',
        text: '',
        hint: '',
        valid: 'YES',
        noConfirm: false,
        later: 'LATER',
        rawText: false,
        loading: false,
        loadingText: ''
    };

    public ctx: ArchivesDialogOptions;

    constructor(
        public dialogRef: MatDialogRef<ArchivesDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ArchivesDialogOptions
    ) {
        this.ctx = _.merge(this._defaultCtx, _.cloneDeep(this.data));
    }
    

    onNoClick(): void {
        this.dialogRef.close();
    }
}
